import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    width: stylesConstants.inputFormWidth,
  },
  title: {
    fontWeight: 600,
    width: stylesConstants.inputFormWidth / 2,
  },
  value: {
    width: stylesConstants.inputFormWidth / 2,
    wordBreak: 'break-word'
  },
}));
